<template>
    <div class="notice-scope">
        <div v-for="notice in notices" class="notice-scope__input-field" v-bind:key="notice.id">
            <label :for="`notice_${notice.id}`">
                <input :id="`notice_${notice.id}`"
                       type="checkbox"
                       v-model="notice.selected">
                <span>{{ notice.name }}</span>
            </label>

        </div>
    </div>
</template>

<script>
    export default {
        name: "NoticeScopeComponent",
        props: {
            email: { type: String, default: '' },
            user: { type: String, default: '' },
        },
        data() {
            return {
                notices: [],
            }
        },
        beforeMount() {
            this.axios.get(`/notice/${this.user}`)
                .then((response) => {
                    this.notices = response.data;
                });
        },
        watch: {
            notices: {
                handler() {
                    this.$emit('input', this.notices);
                },
                deep: true
            }
        },
        methods: {

        },
    }
</script>

<style scoped lang="scss">
    .notice-scope {
        &__input-field {
            display: flex;
            justify-content: space-between;
        }
    }
</style>
